/**
 * @file components/common/ResponsiveDrawer.tsx
 * @description antd Drawer 的響應式包裝：根據斷點自動切換寬度。
 *
 * 預設策略：
 *   isMobile        → 100% （全屏抽屜）
 *   isPadPortrait   → 90%
 *   isPadLandscape  → 560px
 *   desktop         → props.width 或 antd 默認 378
 *
 * 注意：antd Drawer 的 width 對 placement='top'|'bottom' 無效，
 * 此 wrapper 僅針對 left/right placement 生效（最常見場景）。
 */
import { Drawer, type DrawerProps } from 'antd';
import { useResponsive } from '@/hooks/useResponsive';

export interface ResponsiveDrawerProps extends DrawerProps {
  /** 桌面（≥ xl）下的寬度，未提供時走 antd 默認 */
  width?: DrawerProps['size'];
}

export function ResponsiveDrawer(props: ResponsiveDrawerProps) {
  const { isMobile, isPadPortrait, isPadLandscape } = useResponsive();
  const { width: desktopWidth, placement, ...rest } = props;

  /** 僅 left/right placement 套用響應式寬度 */
  const isHorizontal = placement === undefined || placement === 'left' || placement === 'right';

  let resolvedWidth: DrawerProps['size'];
  if (!isHorizontal) {
    resolvedWidth = desktopWidth; // top/bottom 用 height 控制，width 不適用
  } else if (isMobile) {
    resolvedWidth = '100%';
  } else if (isPadPortrait) {
    resolvedWidth = '90%';
  } else if (isPadLandscape) {
    resolvedWidth = 560;
  } else {
    resolvedWidth = desktopWidth;
  }

  return <Drawer {...rest} placement={placement} size={resolvedWidth} />;
}

export default ResponsiveDrawer;
